(() => {
  if (window.VelvetAboutInitialized) return;
  window.VelvetAboutInitialized = true;

  const reveal = (root = document) => {
    const items = root.querySelectorAll(".velvet-about-reveal:not([data-velvet-reveal-ready])");

    if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      items.forEach((item) => item.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          currentObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    items.forEach((item) => {
      item.dataset.velvetRevealReady = "true";
      observer.observe(item);
    });
  };

  const initScrollTop = (root = document) => {
    root.querySelectorAll("[data-velvet-scroll-top]").forEach((button) => {
      if (button.dataset.initialized === "true") return;
      button.dataset.initialized = "true";

      const update = () => button.classList.toggle("is-visible", window.scrollY > 500);
      window.addEventListener("scroll", update, { passive: true });
      button.addEventListener("click", () => {
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
        });
      });
      update();
    });
  };

  const init = (root = document) => {
    reveal(root);
    initScrollTop(root);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
